import emark from "../../assets/elevare-emark.png";

/**
 * Elevare "E" monogram — the official brand mark (bold teal E with the gold
 * swoosh), extracted from the brand banner and served as a transparent PNG so
 * it matches the real logo exactly everywhere it appears.
 */
export default function ElevareMark({ size = 48, className = "" }) {
  return (
    <img
      src={emark}
      alt="Elevare Solutions"
      width={size}
      height={size}
      loading="eager"
      draggable={false}
      style={{ width: size, height: size, objectFit: "contain" }}
      className={className}
    />
  );
}
